import { useTheme } from 'styled-components';
import {
  Col,
  ENotificationType,
  TRtkErrorType,
  useShowToastNotification,
  useTranslation,
} from '@packages/utils';
import { EIconNames, Icon } from 'components/Base/Icon';
import { useDeleteElcMeetingTATimeMutation } from 'redux/apiSlice/elcs.slice';
import { TRemoveTATimeProps } from './RemoveTATime.types';

const RemoveTATime = ({ elcId, meetingId, taTimeId }: TRemoveTATimeProps) => {
  const { t } = useTranslation({
    keyPrefix:
      'descriptions.admin-portal.elcs.detail.meetings-tab.details.ta-time.delete',
  });
  const theme = useTheme();
  const { showToastNotification } = useShowToastNotification();
  const [deleteTopic, { isLoading }] = useDeleteElcMeetingTATimeMutation();

  const handleSubmit = async (e: {
    stopPropagation: () => void;
    preventDefault: () => void;
  }) => {
    e.stopPropagation();
    if (isLoading) {
      e.preventDefault();
      return;
    }
    try {
      const payload: any = {
        meetingId,
        taTimeId,
      };

      if (elcId) {
        payload.elcId = elcId;
      }

      await deleteTopic(payload).unwrap();
      showToastNotification({
        message: t('SUCCESS_MESSAGE'),
        type: ENotificationType.SUCCESS,
      });
    } catch (err) {
      showToastNotification({
        message: (err as TRtkErrorType)?.data?.message,
        type: ENotificationType.ERROR,
      });
    }
  };

  return (
    <Col onClick={handleSubmit}>
      <Icon
        icon={EIconNames.DELETE_OUTLINED}
        color={theme.colorBlackIconColor}
        className="pointer"
        tooltip={t('DELETE_TOOLTIP')}
      />
    </Col>
  );
};

export default RemoveTATime;
